import MainCard from 'ui-component/cards/MainCard';
import { Button, Grid, Box, Tooltip, TextField, FormControl, MenuItem, Typography, Modal, Menu, Autocomplete } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { useState, useEffect } from 'react';
import { useApi } from 'Service/axios';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import ActionButtons from 'components/Entrada/ActionButtons';
import ActionButtonsCreate from 'components/Entrada/ActionButtonsCreate';
import SaveIcon from '@mui/icons-material/Save';
import { toast } from 'react-toastify';
import { PDFViewer } from '@react-pdf/renderer';
import PdfEntradaNota from 'components/PDF/Estoque/PdfEntradaNota';
import { XmlModal } from './components/XmlModal';
import { useRef } from 'react';
import axios from 'axios';
import { IconPlus } from '@tabler/icons';
import CreateContructionModal from './components/Obras';
import CadastroItensModal from './components/CadastroItens';
import CadastroProjetosModal from './components/CadastroProjetos/CadastroProjetosModal';
import UploadPdfField from '../../../components/FileUpload';

// ============================= INITIALSTATE =============================
const initialState = {
    documento: '',
    emissao: '',
    movimento: new Date(),
    fornecedor: 0,
    obra: null,
    observacao: '',
    itens: []
};

const NovaEntrada = () => {
    // ============================= INSTÂNCIAS =============================
    const api = useApi();
    // ============================= STATES =============================
    const [campos, setCampos] = useState(initialState);
    const [openCreate, setOpenCreate] = useState(false);
    const [itens, setItens] = useState([]);
    const [listAllItens, setListAllItens] = useState([]);
    const [listAllAlmoxarifado, setListAllAlmoxarifado] = useState([]);
    const [listAllLocalizacao, setListAllLocalizacao] = useState([]);
    const [listAllFornecedor, setListAllFornecedor] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);

    const [openImportXmlModal, setOpenImportXmlModal] = useState(false);
    const [listAllObras, setListAllObras] = useState([]);
    const [obraSelecionada, setObraSelecionada] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const columns = [
        { field: 'descricao', headerName: 'DESCRIÇÃO', flex: 2 },
        { field: 'unidade', headerName: 'UN', flex: 1 },
        { field: 'quantidade', headerName: 'QNTD', flex: 0.5 },
        {
            field: 'valor_unitario',
            headerName: 'VALOR UN.',
            flex: 1,
            valueGetter: (params) => params.row.valor_unitario.toFixed(2)
        },
        {
            field: 'valor_total',
            headerName: 'VALOR T.',
            flex: 1,
            valueGetter: (params) => params.row.valor_total.toFixed(2)
        },
        {
            field: 'acao',
            headerName: 'AÇÕES',
            flex: 1,
            sortable: false,
            renderCell: (params) => (
                <ActionButtons
                    setItens={setItens}
                    row={params.row}
                    removerCampoItem={removerCampoItem}
                    atualizarCampoItem={atualizarCampoItem}
                    listAllItens={listAllItens}
                    listAllAlmoxarifado={listAllAlmoxarifado}
                    listAllLocalizacao={listAllLocalizacao}
                />
            )
        }
    ];

    const somaValorTotal = itens.reduce((acumulador, objeto) => {
        return acumulador + Number(objeto.valor_total);
    }, 0);

    // ============================= FUNÇÕES =============================

    const atualizarCampo = (campo, valor) => {
        setCampos((prev) => ({ ...prev, [campo]: valor }));
    };

    const adicionarCampoItem = () => {
        setCampos((prevCampos) => ({
            ...prevCampos,
            itens: [
                ...prevCampos.itens,
                {
                    item_id: '',
                    descricao: '',
                    quantidade: 1,
                    unidade: '',
                    valor_unitario: 0,
                    valor_total: 0,
                    almoxarifado_id: '',
                    localizacao_id: '',
                    observacao: ''
                }
            ]
        }));
    };

    const removerCampoItem = (uuid) => {
        setItens((prevItens) => {
            const novosItens = [...prevItens];
            const filtredItens = novosItens.filter((item) => item.uuid != uuid);
            return filtredItens;
        });
        setCampos((prevCampos) => {
            const novosCampos = { ...prevCampos };
            novosCampos.itens.filter((item) => item.uuid != uuid);
            return novosCampos;
        });

        // fechar modal
        if (openCreate) {
            setOpenCreate(false);
        }
    };

    const atualizarCampoItem = async (uuid, campo, valor) => {
        setCampos((prevCampos) => {
            const novosCampos = { ...prevCampos };
            novosCampos.itens[campos?.itens?.length - 1][campo] = valor;
            return novosCampos;
        });
    };

    const handleSelectionModelChange = (newSelection) => {
        setSelectedItems(newSelection);
    };

    const handleClose = () => {
        setOpenCreate(false);
    };

    const handleOpenAndCreateCampoItem = () => {
        setOpenCreate(true);
        adicionarCampoItem();
    };

    const getAllData = async () => {
        try {
            const [responseAlmoxarifado, responseLocalizacao, responseItens, responseFornecedor, obras] = await Promise.all([
                api.getAllAlmoxarifado(),
                api.getAllLocalizacao(),
                api.getAllItens(),
                api.getAllFornecedor(),
                api.getAllObra()
            ]);
            setListAllAlmoxarifado(responseAlmoxarifado.data.almoxarifados);
            setListAllLocalizacao(responseLocalizacao.data.localizacao);
            setListAllItens(responseItens.data.itens);
            setListAllFornecedor(responseFornecedor.data.fornecedores);
            setListAllObras(obras?.data?.obras);
        } catch (error) {
            toast.error(error?.message);
        }
    };

    const getDate = () => {
        const date = new Date();
        let currentDay = String(date.getDate()).padStart(2, '0');
        let currentMonth = String(date.getMonth() + 1).padStart(2, '0');
        let currentYear = date.getFullYear();
        let currentDate = `${currentYear}-${currentMonth}-${currentDay}`;
        setCampos((prev) => ({ ...prev, movimento: currentDate }));
    };

    //====== pdf ======
    useEffect(() => {
        console.log(selectedFile, 'selectedFile');
    }, [selectedFile]);

    async function uploadPdf(entradaId) {
        console.log('🚀 ~ uploadPdf ~ entradaId:', entradaId);
        try {
            const formData = new FormData();
            formData.append('notaFiscal', selectedFile);
            await api.sendPdf(formData, entradaId);
            window.location.reload();
        } catch (error) {
            toast.error(`Erro ao enviar arquivo pdf: ${error.message}`);
        }
    }
    //====== SUBMIT ======
    const handleSubmit = async (e, campos) => {
        e.preventDefault();
        itens.forEach((item) => {
            delete item.id;
        });
        const dataItems = { entrada: campos, itens: itens };
        if (!dataItems.entrada.emissao) return toast.error('Data de emissão é obrigatória');
        if (!dataItems.itens.length) return toast.error('É necessário cadastrar pelo menos um item');
        try {
            setLoading(true);
            const response = await api.createEntradaEstoque(dataItems.entrada, dataItems.itens);
            const entradaId = response?.data?.data?.entrada?.id;
            toast.success('Entrada cadastrada');

            if (selectedFile) {
                await uploadPdf(entradaId);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            toast.error(`Erro ao criar entrada: ${error.message}`);
        }
    };

    useEffect(() => {
        getAllData();
        getDate();
    }, []);

    // XML DATA FUNCTIONS
    const [xmlResponse, setXmlResponse] = useState('');
    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
            setOpenImportXmlModal(true);
        }
    };

    const handleFileChange = async (event) => {
        const file = event.target.files?.[0];

        if (file) {
            try {
                const formData = new FormData();
                formData.append('xml', file);
                const { data } = await api.sendXml(formData);
                console.log('🚀 ~ handleFileChange ~ data:', data);

                setXmlResponse(data?.dadosXML);
            } catch (error) {
                toast.error(`Erro ao processar XML: ${error?.response?.data?.message ?? error.message}`);
            }
        }
    };
    const handleCloseXmlModal = () => {
        setXmlResponse(null);
        setOpenImportXmlModal(false);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const [xmlIsChanged, setXmlIsChanged] = useState(1);

    useEffect(() => {
        if (xmlIsChanged > 1) {
            getAllData();
        }
    }, [xmlIsChanged]);

    return (
        <MainCard title="Nova Entrada" sx={{ position: 'relative' }}>
            <Box sx={{ position: 'absolute', right: '1em', top: '1em' }}>
                <XmlModal
                    open={openImportXmlModal}
                    setOpen={setOpenImportXmlModal}
                    handleButtonClick={handleButtonClick}
                    xmlResponse={xmlResponse}
                    setCampos={setCampos}
                    setItens={setItens}
                    handleClose={handleCloseXmlModal}
                    setXmlIsChanged={setXmlIsChanged}
                />
                <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} accept=".xml" />
            </Box>

            <div style={{ position: 'absolute', top: '-8.3em', right: '9em' }}>
                <Tooltip title="Cadastros">
                    <Button
                        sx={{ position: 'absolute', top: '130px', right: '50px' }}
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        variant="outlined"
                    >
                        <IconPlus />
                    </Button>
                </Tooltip>

                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCloseMenu}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}
                >
                    <MenuItem>
                        <CreateContructionModal setListAllObras={setListAllObras} />
                    </MenuItem>
                    <MenuItem>
                        <CadastroItensModal getItens={getAllData} />
                    </MenuItem>
                    {/* <MenuItem>
                        <CadastroProjetosModal allObra={listAllObras} getAllProjeto={getAllData} />
                    </MenuItem> */}
                </Menu>
            </div>
            <Grid container spacing={gridSpacing}>
                <ActionButtonsCreate
                    open={openCreate}
                    handleClose={handleClose}
                    setItens={setItens}
                    campos={campos}
                    adicionarCampoItem={adicionarCampoItem}
                    atualizarCampoItem={atualizarCampoItem}
                    listAllItens={listAllItens}
                    listAllAlmoxarifado={listAllAlmoxarifado}
                    listAllLocalizacao={listAllLocalizacao}
                />

                <Box sx={{ width: '80%', margin: '0 auto' }}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', marginLeft: '1em', marginTop: '1em' }}>
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '1em',
                                    width: '100%',
                                    marginBottom: '1em'
                                }}
                            >
                                <FormControl fullWidth>
                                    <TextField
                                        type="text"
                                        label="Nota"
                                        value={campos.documento}
                                        onChange={(e) => atualizarCampo('documento', e.target.value)}
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <TextField
                                        type="date"
                                        label="Data emissão"
                                        value={campos.emissao}
                                        onChange={(e) => atualizarCampo('emissao', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <TextField
                                        type="date"
                                        label="Movimento"
                                        value={campos.movimento}
                                        disabled
                                        onChange={(e) => atualizarCampo('movimento', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        label="Fornecedor"
                                        value={campos.fornecedor}
                                        onChange={(e) => atualizarCampo('fornecedor', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        {listAllFornecedor.map((fornecedor) => (
                                            <MenuItem key={fornecedor.id} value={fornecedor.id}>
                                                {fornecedor.nome_fantasia}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                                <FormControl fullWidth sx={{ maxWidth: '300px' }}>
                                    <Autocomplete
                                        options={listAllObras}
                                        sx={{ height: '50px' }}
                                        getOptionLabel={(obra) => `${obra.id} - ${obra.descricao}`}
                                        value={listAllObras.find((obra) => obra.id === campos.obra)}
                                        onChange={(e, newValue) => {
                                            atualizarCampo('obra', newValue ? newValue.id : null);
                                            // setObraSelecionada(newValue);
                                        }}
                                        renderInput={(params) => <TextField {...params} label="Obra" />}
                                    />
                                </FormControl>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '1em', width: '100%' }}>
                                <FormControl sx={{ width: '50%' }}>
                                    <TextField
                                        multiline
                                        minRows={3}
                                        label="Observação"
                                        placeholder="Observação"
                                        value={campos.observacao}
                                        onChange={(e) => atualizarCampo('observacao', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                                <UploadPdfField
                                    onFileChange={() => {
                                        console.log('enviou');
                                    }}
                                    setSelectedFile={setSelectedFile}
                                    selectedFile={selectedFile}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%', marginTop: '2em', borderTop: '2px dashed #eee' }}>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '1em' }}>
                                <Box>
                                    <Typography variant="h4">Relação de itens</Typography>
                                </Box>
                                <Box>
                                    <Tooltip title="Adicionar item">
                                        <Button variant="contained" color="success" onClick={(e) => handleOpenAndCreateCampoItem()}>
                                            <AddIcon />
                                        </Button>
                                    </Tooltip>
                                </Box>
                            </Box>

                            <Box sx={{ marginTop: '2em', display: 'flex', flexDirection: 'column', height: '300px' }}>
                                <DataGrid
                                    rows={itens}
                                    columns={columns}
                                    getRowHeight={() => 'auto'}
                                    hideFooter={true}
                                    onSelectionModelChange={() => handleSelectionModelChange(params.id)}
                                    getRowId={(row) => row.uuid}
                                />
                                <Box
                                    sx={{
                                        width: '40%',
                                        marginLeft: 'auto',
                                        marginTop: '1em',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <h4>Valor Total:</h4>
                                        <Box
                                            sx={{
                                                border: '1px solid #ccc',
                                                padding: '8px 16px',
                                                borderRadius: 2
                                            }}
                                        >
                                            {somaValorTotal.toFixed(2)}
                                        </Box>
                                    </Box>

                                    <Tooltip title="Salvar entrada">
                                        <Button
                                            variant="contained"
                                            color="success"
                                            disabled={loading}
                                            onClick={(e) => handleSubmit(e, campos)}
                                        >
                                            <SaveIcon />
                                        </Button>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Grid>
        </MainCard>
    );
};

export default NovaEntrada;
